import { render, staticRenderFns } from "./Inputnumber.vue?vue&type=template&id=2d997062"
import script from "./Inputnumber.vue?vue&type=script&lang=js"
export * from "./Inputnumber.vue?vue&type=script&lang=js"
import style0 from "./Inputnumber.vue?vue&type=style&index=0&id=2d997062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports